import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["actionId", "action", "getHeaderTitle", "flowObjectTypeId"];
import PropTypes from 'prop-types';
// @ts-expect-error untyped module
import ObjectTypeIdType from 'customer-data-objects-ui-components/propTypes/ObjectTypeIdType';
import AutomationBuilderCard from 'automation-ui-flow-core/canvas/AutomationBuilderCard';
import Action from 'automation-ui-action-features/records/Action';
import ListBranchActionSummary from 'automation-ui-action-features/actions/list-branch/ListBranchActionSummary';
import { jsx as _jsx } from "react/jsx-runtime";
function ListBranchActionCard(_ref) {
  let {
      actionId,
      action,
      getHeaderTitle,
      flowObjectTypeId
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const content = /*#__PURE__*/_jsx(ListBranchActionSummary, {
    action: action,
    flowObjectTypeId: flowObjectTypeId
  });
  return /*#__PURE__*/_jsx(AutomationBuilderCard, Object.assign({}, rest, {
    headerTitle: getHeaderTitle({
      actionId
    }),
    content: content
  }));
}
ListBranchActionCard.propTypes = {
  getHeaderTitle: PropTypes.func.isRequired,
  action: PropTypes.instanceOf(Action).isRequired,
  flowObjectTypeId: ObjectTypeIdType.isRequired,
  actionId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
export default ListBranchActionCard;